import { recordTrack } from '@saucelabs/sl-util-segmentio';

const AUTOMATION_TEST_RESULTS_KEY_PREFIX = 'Automation Test Results -';
const MANUAL_PREFIX = 'Manual - ';
const MANUAL_TEST_DETAILS_PREFIX = 'Manual Test Details - ';
const MANUAL_TEST_RESULTS_PREFIX = 'Manual Test Results - ';
const RDC_PREFIX = 'Real Devices - ';
const RDC_TEST_RESULTS_PREFIX = 'automated__test-results__real-devices__';
export const PRODUCT_AREA = 'Growth';
export const PRODUCT_SUB_AREA = 'Automated Test Results (Empty State)';

export const NAVIGATION_EVENTS = Object.freeze({
  MANUAL_JOB: `${MANUAL_TEST_RESULTS_PREFIX}Navigate to Manual Test`,
  MANUAL_VIEW_JOB_LIST: `${MANUAL_PREFIX}View Job List`,
  MANUAL_TEST_DETAILS_NAVIGATE_TO_JOB_DETAILS: `${MANUAL_TEST_DETAILS_PREFIX}Navigate to Job Details`,
  VIEW_RDC_JOB_LIST: `${RDC_PREFIX}View Job List`,
  VIEW_JOB_DETAILS: 'nav/view/job-details',
  VIEW_RUNNING_JOB: 'nav/view/job-running',
});

export const JOB_TYPES = Object.freeze({
  AUTOMATED: 'automated',
  MANUAL: 'manual',
  RDC: 'rdc',
});

export const DEVICE_TYPES = Object.freeze({
  RDC: 'rdc',
  VDC: 'vdc',
});

// Mirror from packages/web-ui-manual/src/constants
export const CONFIGURATION_TEST_TYPES = Object.freeze({
  APP: 'APP',
  WEB: 'WEB',
});

export const JOBS_UI_ELEMENTS = Object.freeze({
  NEW_WEB_TEST_BUTTON_BREADCRUMB: 'Breadcrumb New Live Web Test Button',
  NEW_APP_TEST_BUTTON_BREADCRUMB: 'Breadcrumb New Live App Test Button',
  NEW_WEB_TEST_BUTTON_EMPTY_STATE: 'Empty State New Live Web Test Button',
  NEW_APP_TEST_BUTTON_EMPTY_STATE: 'Empty State New Live App Test Button',
});

export const DOCUMENTATION_EVENTS = Object.freeze({
  HELPFUL_RESOURCE: `${MANUAL_PREFIX}Select Helpful Resources`,
  SUPPORT_PORTAL: 'docs/click/getting-started__support-portal',
  DOCUMENTATION_WIKI: 'docs/click/getting-started__documentation',
  REFER_A_FRIEND: 'docs/click/getting-started__refer-a-friend',
  ANNOTATING_TESTS: 'docs/click/automated__builds__annotate-tests-button',
  RDC_TESTS: 'docs/click/automated__test-results__real-devices__detailed-info-link',
});

export const ONBOARDING_EVENTS = Object.freeze({
  VIDEO_LOADED: 'Onboarding-Video-Loaded',
  VIDEO_PLAYED: 'Onboarding-Video-Played',
  VIDEO_ENDED: 'Onboarding-Video-Ended',
  DOCUMENTATION_OPEN: 'docs/click/automated__test-results__virtual-cloud__documentation-link',
});

const BUILDS_PREFIX = 'Builds -';

export const BUILDS_EVENTS = Object.freeze({
  TOGGLE_TYPE: `${BUILDS_PREFIX} Toggle Build Type`,
  SELECT_OWNER_FILTER: `${BUILDS_PREFIX} Select Owner Filter`,
  SELECT_STATUS_FILTER: `${BUILDS_PREFIX} Select Status Filter`,
  DESELECT_STATUS_FILTER: `${BUILDS_PREFIX} Deselect Status Filter`,
  VIEW_BUILD: `${BUILDS_PREFIX} View Build`,
  TOGGLE_FAILED_JOBS: `${BUILDS_PREFIX} Toggle Failed Jobs`,
});

export const RDC_DOCUMENTATION_EVENTS = Object.freeze({
  ESPRESSO_DEMO: `docs/click/${RDC_TEST_RESULTS_PREFIX}espresso`,
  XCUITEST_DEMO: `docs/click/${RDC_TEST_RESULTS_PREFIX}xcuitest`,
  NIGHTWATCH_DEMO: `docs/click/${RDC_TEST_RESULTS_PREFIX}nightwatch`,
  PROTRACTOR_DEMO: `docs/click/${RDC_TEST_RESULTS_PREFIX}protractor`,
  ESPRESSO_XCUITEST_DOCS: `docs/click/${RDC_TEST_RESULTS_PREFIX}espresso_xcuitest`,
  APPIUM_DOCS: `docs/click/${RDC_TEST_RESULTS_PREFIX}appium`,
  SAUCE_LABS_TRAINING: `docs/click/${RDC_TEST_RESULTS_PREFIX}sauce-labs-training-link`,
});

export const CTA_EVENTS = Object.freeze({
  SHOW_NEWER_JOBS: `${AUTOMATION_TEST_RESULTS_KEY_PREFIX} Show Newer Jobs`,
  SHOW_OLDER_JOBS: `${AUTOMATION_TEST_RESULTS_KEY_PREFIX} Show Older Jobs`,
  MANUAL_TEST_RESULTS_TOGGLE_DEVICE_TYPE: `${MANUAL_TEST_RESULTS_PREFIX}Toggle Device Type`,
  MANUAL_TEST_RESULTS_SHOW_NEWER_JOBS: `${MANUAL_TEST_RESULTS_PREFIX}Show Newer Jobs`,
  MANUAL_TEST_RESULTS_SHOW_OLDER_JOBS: `${MANUAL_TEST_RESULTS_PREFIX}Show Older Jobs`,
});

export const MANUAL_FILTER_EVENTS = Object.freeze({
  FILTER_SET: `${MANUAL_TEST_RESULTS_PREFIX}Filters Set`,
});

export const JOBS_EVENTS = Object.freeze({
  OBJECT_CLICKED: 'Object Clicked',
});

export const trackEvent = recordTrack;
export default trackEvent;
